module.exports = __webpack_public_path__ + "media/images/logo-25100b91a97a57ae0259db77e83583d0.svg";